import React, { useCallback, useState } from 'react';
import { Observable } from 'rxjs';
import useRemove from './use-remove';
import Spinner from '../../../../components/common/spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import css from '../index.module.css';

interface Props {
  id: string;
  onRemove: (id: string) => Observable<any>;
  content?: string;
}

export default function RemoveIcon({
  id,
  onRemove,
  content = 'pages.crop.vaad_liz_reports_v2.remove_modal.content',
}: Props) {
  const [isRemoving, setIsRemoving] = useState(false);
  const { modal, confirmRemove } = useRemove(content);

  const remove = useCallback(() => {
    setIsRemoving(true);
    confirmRemove(id, onRemove, () => setIsRemoving(false));
  }, [confirmRemove, id, onRemove]);

  return (
    <>
      {isRemoving ? (
        <Spinner visible size="sm" />
      ) : (
        <span className={css['close']} onClick={remove}>
          <FontAwesomeIcon icon={faTimes} />
        </span>
      )}

      {modal}
    </>
  );
}
